import {Assignment} from './assignment';
import {LearningOutcome} from './learning-outcome';

export class User {
  email: string;
  firstName: string;
  lastName: string;
  requestKey: string;
  avatarUrl: string;
  assignments: Assignment[];
  learningOutcomes: LearningOutcome[];
  constructor() {
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.requestKey = '';
    this.avatarUrl = '';
    this.assignments = [];
    this.learningOutcomes = [];
  }

  public getFullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  public getInitials(): string {
    return `${this.firstName.charAt(0)}${this.lastName.charAt(0)}`;
  }

  public getInitialsUpperCase(): string {
    return `${this.firstName.charAt(0).toUpperCase()}${this.lastName.charAt(0).toUpperCase()}`;
  }

  public getInitialsLowerCase(): string {
    return `${this.firstName.charAt(0).toLowerCase()}${this.lastName.charAt(0).toLowerCase()}`;
  }

  public setUser(user: {
    email: string;
    firstName: string;
    lastName: string;
    requestKey: string;
    avatarUrl: string;
    assignments: Assignment[];
    learningOutcomes: LearningOutcome[];
  }) {
    this.email = user.email;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.requestKey = user.requestKey;
    this.avatarUrl = user.avatarUrl;
    this.assignments = user.assignments;
    this.learningOutcomes = user.learningOutcomes;
  }

  public clearUser() {
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.requestKey = '';
    this.avatarUrl = '';
    this.assignments = [];
    this.learningOutcomes = [];
  }

}
